import ContactForm from '@/components/ContactForm'
import EntryHeader from '@/components/EntryHeader'
import FlexibleContent from '@/components/FlexibleContent'
import Main from '@/components/Main'
import Posts from '@/components/Posts'
import SEO from '@/components/SEO'
import dynamic from 'next/dynamic'

// Only leader pages carry a profile, so it stays out of every other page's bundle.
const LeaderProfile = dynamic(() => import('@/components/FlexibleContent/LeaderProfile'))
// ssr: false to match how every other Swiper component on the site is loaded.
const LeadershipSlider = dynamic(() => import('@/components/LeadershipSlider'), { ssr: false })

export default function Component(props) {
  // Loading state for previews
  if (props.loading) {
    return null
  }

  const page = props?.data?.page
  const metaDesc = page?.seo?.metaDesc
  const { title, featuredImage } = page ?? { title: '' }
  const flexibleContent = page?.template?.flexibleContent?.flexibleContentFields ?? []
  const form = props?.data?.contactForm
  const headerForm = props?.data?.headerForm
  const seoTitle = page?.seo?.title

  // The field group always returns an object, so presence is judged on its contents —
  // any populated field counts, since naming only three meant an editor who filled just
  // the intro or the socials got no profile at all.
  const leaderProfile = page?.leaderProfile
  const hasLeaderProfile = Object.entries(leaderProfile ?? {}).some(
    ([key, value]) => !['__typename', 'fieldGroupName'].includes(key) && (Array.isArray(value) ? value.length > 0 : Boolean(value))
  )

  // The profile replaces the page header, so its name is the page's only h1. Falling back
  // to the page title keeps one there even if the field is left blank.
  const leaderProfileFields = hasLeaderProfile ? { ...leaderProfile, leaderName: leaderProfile?.leaderName || title } : null

  // Siblings, read through the parent rather than a hardcoded /leadership/ uri. The
  // slider drops the current page from the list itself.
  const siblingLeaders = page?.parent?.node?.children?.nodes ?? []

  return (
    <>
      <SEO title={seoTitle || title} description={metaDesc} imageUrl={featuredImage?.node?.sourceUrl} />

      {/* The profile carries its own hero, so showing both would stack two of them. */}
      {!hasLeaderProfile && <EntryHeader pageFields={page} image={featuredImage?.node} form={headerForm} title={title} />}

      <Main>
        {hasLeaderProfile && <LeaderProfile fields={leaderProfileFields} headingLevel={1} />}

        {hasLeaderProfile && <LeadershipSlider leaders={siblingLeaders} currentUri={page?.uri} />}

        <FlexibleContent content={flexibleContent} />

        <section data-aos="fade-up">
          <Posts posts={props?.data?.posts?.nodes} id="posts-list" />
        </section>
      </Main>

      {form && <ContactForm form={form} />}
    </>
  )
}
